import axios from "axios";

export const fetchMachinePace = async (machineId, timespan, companyKey) => {
    const response = await axios.get("api/machinepace/"+ machineId + "?timespan="+ timespan + "&companyKey="+ companyKey);
    const machinePace = response.data;
    return machinePace;
}

export const fetchMachinePaceDetails = async (machineId, productionOrderNo, companyKey) => {
    const response = await axios.get("api/machinepace/details/"+ machineId + "?productionOrderNo="+ productionOrderNo + "&companyKey="+ companyKey);
    const machinePace = response.data;
    return machinePace;
}